import React, { useContext } from "react";
import "./evacuationPage.css";
import TopBar from "../../../components/TopBarComponent/Topbar";
import { Container } from "react-bootstrap";
import { EvacuationContext } from "../EvacuationView";
import LeftArrow from "../../../assets/images/leftArrow.svg";
import TableBody from "../../../constants/dummyData.json";
import DataTable from "../../../components/DataTableComponent/DataTable";
import { Spinner } from "react-bootstrap";
import AlertBox from "../../../components/AlertComponent/AlertBox";
const EvacuationPage = ({ textContents }) => {
  const {
    goBack,
    evacuactionDetailPage,
    ertData,
    showAlert,
    setShowAlert,
    alertMessage,
    logout,
    statusCode,
    handleAlertSubmit,
    spinnerStatus 
  } = useContext(EvacuationContext);

  const tableHeader = [
    {
      title: "ERT Name",
      prop: "ERTName",
      cell: (row) => (
        <div
          className="ertHeaderEvacuation"
          onClick={() => {
            evacuactionDetailPage(row.ERTName, row.id);
          }}
        >
          {row.ERTName}
        </div>
      ),
    },
    { title: "Total Count", prop: "count" },
  ];

  return (
    <div className="ert">
           {spinnerStatus && (
        <div className="spinner-overlay-report">
          <Spinner size="xl" className="custom-spinner-report" />
        </div>
      )}
      <TopBar />
      <AlertBox
        show={showAlert}
        setShow={setShowAlert}
        alertMessage={alertMessage}
        handleSubmit={
          statusCode == 401 ? () => logout() : () => handleAlertSubmit()
        }
      />
      <Container>
        <div className="filterContainerZoneERT">
          <div className="arrowContainerZoneERT" onClick={() => goBack()}>
            <img src={LeftArrow} alt="img" className="leftArrowZoneERT" />
          </div>
          <div className="filterByContainerZoneERT">
            <span className="filterByZoneText">{"ERT"}</span>
          </div>
        </div>

        <div className="tableContainerStatusERT">
          <DataTable
            tableData={ertData}
            header={tableHeader}
            isPagination={false}
          />
        </div>
      </Container>
    </div>
  );
};

export default EvacuationPage;
